import React, { useState } from "react";
import LoadingScreen from "../components/LoadingScreen";
import ScrollProgress from "../components/ScrollProgress";
import BackToTop from "../components/BackToTop";
import Header from "../components/Header";
import Hero from "../components/Hero";
import MetricsBar from "../components/MetricsBar";
import SkillsGrid from "../components/SkillsGrid";
import ExperienceTimeline from "../components/ExperienceTimeline";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && <LoadingScreen onLoadComplete={() => setIsLoading(false)} />}
      
      {!isLoading && (
        <div className="homepage" style={{ background: "var(--bg-primary)" }}>
          <ScrollProgress />
          <BackToTop />
          <Header />
          <Hero />
          <MetricsBar />
          <SkillsGrid />
          <ExperienceTimeline />
          <Projects />
          <Contact />
          <Footer />
        </div>
      )}
    </>
  );
};

export default HomePage;
